import React from "react"
import "../Dashboard.css"

export const Readme = () => {
    return <article className="view">
        <td className="d-block color-fg-default comment-body markdown-body wb-break-word js-comment-body">
            <h1 dir="auto">Project README Guidelines</h1>
            <p dir="auto">You can add a README file to your repository to tell other people why your project is useful, what they can do with your project, and how they can use it.</p>
            <h1 dir="auto">What's in a README?</h1>
            <p dir="auto">README files typically include information on:</p>
            <ul dir="auto">
                <li>Primary Features - What does this project do?</li>
                <li>Target Audience - Who is it for?</li>
                <li>Purpose - Why the project is useful/what problem does it solve?</li>
                <li>Getting Started - How can someone test out the project?</li>
                <li>Help - Where/How can users get help with your project?</li>
                <li>Contributions - Who contributed to this project/What did they contribute?</li>
            </ul>
            <p dir="auto">Other things you may want to include are:</p>
            <ul dir="auto">
                <li>Images of ERD, Wirframes, etc.</li>
                <li>Images of finished product</li>
                <li>Animated Demos of primary features in action</li>
                <li>Link to your planning documentation</li>
            </ul>
            <h2 dir="auto">Resources</h2>
            <p dir="auto"><a href="https://dev.to/kelli/demo-your-app-in-your-github-readme-with-an-animated-gif-2o3c" rel="nofollow">How To Add Animated Demos (Gifs) To Your README.md</a></p>
            <p dir="auto"><a href="https://www.loom.com/" rel="nofollow">Loom - Screen Recording</a></p>
            <p dir="auto"><a href="https://gif.ski/" rel="nofollow">Gifski - Turn videos into gifs</a></p>
            <p dir="auto"><a href="https://www.cnet.com/how-to/7-ways-you-can-take-screenshots-in-windows-10/" rel="nofollow">7 Ways You Can Take A Screenshot on Windows 10</a></p>
            <p dir="auto"><a href="https://support.apple.com/en-us/HT201361" rel="nofollow">How To Take A Screenshot On Your Mac</a></p>
            <h2 dir="auto">Make Your README Readable</h2>
            <h3 dir="auto">Markdown Syntax</h3>
            <p dir="auto">Markdown is a plain text formatting syntax aimed at making writing for the internet easier.</p>
            <p dir="auto"><a href="https://docs.github.com/en/github/creating-cloning-and-archiving-repositories/about-readmes">Github Documentation</a></p>
            <h3 dir="auto">Resources</h3>
            <ul dir="auto">
                <li>
                    <p dir="auto"><a href="https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet">Markdown Cheatsheet</a></p>
                </li>
                <li>
                    <p dir="auto"><a href="https://www.webfx.com/tools/emoji-cheat-sheet/" rel="nofollow">Emoji Cheat Sheet</a></p>
                </li>
                <li>
                    <p dir="auto"><a href="https://shields.io/category/chat" rel="nofollow">Shields</a></p>
                </li>
            </ul>
            <h3 dir="auto">Basic README Template</h3>
            <p dir="auto"><a href="https://www.makeareadme.com/" rel="nofollow">Make A README - Suggested Template</a></p>
            <h3 dir="auto">Example READMEs</h3>
            <p dir="auto"><a href="https://github.com/heymonicakay/wideRetriever">Wide Retriever - Client Side Capstone by Monica Kay Provence</a></p>
            <p dir="auto"><a href="https://github.com/NSS-Day-Cohort-42/rare-news-hounds">Rare: Media Publication App by Team News Hounds</a></p>
            <p dir="auto"><a href="https://github.com/egeehartz/gatherings-app">Gatherings - Client Side Capstone by Emily Hartzell</a></p>
            <p dir="auto"><a href="https://github.com/nss-day-cohort-47/holiday-road-badland-bandits">Holiday Road - Itinerary App by Team Badland Bandits</a></p>
        </td>
    </article>
}